import React from 'react';
import ModalTextInput from './components/ModalTextInput';
import SuggestionsWrapper from './components/SuggestionsWrapper';
import SuggestionsList from './components/SuggestionsList';

const Suggestions = ({
    anchorRef,
    isModal,
}: {
    anchorRef: React.RefObject<HTMLDivElement>;
    isModal: boolean;
}) => (
    <SuggestionsWrapper anchorRef={anchorRef} isModal={isModal}>
        <>
            {isModal && <ModalTextInput />}
            <SuggestionsList />
        </>
    </SuggestionsWrapper>
);

export default Suggestions;
